// Shown after sign-in when the caller can manage several profiles: their email's own, plus any shared with them.

import React from 'react';
import { COLORS, FONTS } from 'styles/theme';

const { dark } = COLORS;

const overlay = {
  position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(20, 20, 20, 0.45)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px',
};

const card = {
  width: '100%', maxWidth: '420px', maxHeight: '90vh', overflowY: 'auto',
  background: '#fff', borderRadius: '14px', padding: '28px 24px',
  boxShadow: '0 12px 40px rgba(0, 0, 0, 0.18)', fontFamily: FONTS.sans, color: dark,
};

const rowBtn = (active) => ({
  width: '100%', display: 'flex', alignItems: 'center', gap: '12px', textAlign: 'left',
  padding: '14px 16px', borderRadius: '10px', cursor: 'pointer', fontFamily: FONTS.sans,
  border: active ? `2px solid ${dark}` : '1px solid #e2dccd',
  background: active ? COLORS.creamAlt : '#fff', color: dark,
});

const initial = {
  width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: '#f9a826', color: '#fff', fontWeight: 700, fontSize: '16px',
};

const linkBtn = {
  background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: dark,
  fontSize: '14px', fontWeight: 600, textDecoration: 'underline', fontFamily: FONTS.sans,
};

const norm = (v) => String(v || '').trim().toLowerCase();

// Profiles sharing a first name get their last name, or their ID when that still doesn't tell them apart.
const profileLabel = (p, profiles) => {
  const sameFirst = profiles.filter((o) => norm(o.firstName) === norm(p.firstName));
  if (sameFirst.length < 2) return { name: p.fullName || p.firstName || 'Unnamed profile' };
  const name = [p.firstName || 'Unnamed profile', String(p.lastName || '').trim()].filter(Boolean).join(' ');
  const lastNameUnique = norm(p.lastName) && sameFirst.filter((o) => norm(o.lastName) === norm(p.lastName)).length === 1;
  return lastNameUnique ? { name } : { name, subtitle: `ID ${p.token}` };
};

export default function ProfilePicker({ profiles, activeToken, onPick, onClose }) {
  return (
    <div style={overlay} role="dialog" aria-modal="true" aria-labelledby="profile-picker-title">
      <div style={card}>
        <div id="profile-picker-title" style={{ fontFamily: FONTS.serif, fontSize: '26px', fontWeight: 700, marginBottom: '6px' }}>
          Who are you managing?
        </div>
        <div style={{ fontSize: '14px', color: COLORS.text, marginBottom: '20px', lineHeight: 1.5 }}>
          Choose whose plan to manage. You can switch at any time.
        </div>

        <div style={{ display: 'grid', gap: '10px' }}>
          {profiles.map((p) => {
            const label = profileLabel(p, profiles);
            const subtitle = [p.via === 'granted' && p.email, label.subtitle].filter(Boolean).join(' · ');
            return (
              <button key={p.token} type="button" style={rowBtn(p.token === activeToken)} onClick={() => onPick(p)}>
                <span style={initial} aria-hidden="true">{(p.firstName || '?').charAt(0).toUpperCase()}</span>
                <span style={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 }}>
                  <span style={{ fontSize: '16px', fontWeight: 600 }}>{label.name}</span>
                  {subtitle && (
                    <span style={{ fontSize: '12px', color: COLORS.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {subtitle}
                    </span>
                  )}
                </span>
              </button>
            );
          })}
        </div>

        {onClose && (
          <div style={{ marginTop: '20px', textAlign: 'right' }}>
            <button type="button" style={linkBtn} onClick={onClose}>Cancel</button>
          </div>
        )}
      </div>
    </div>
  );
}
